import classNames, { Argument } from 'classnames'
import React, { ReactNode } from 'react'

import { isHyphenatedLocale } from '../locale/i18n'

const Heading = ({
  className,
  isLeftAligned,
  text,
  children,
  variant = 'title',
  as: As = 'h2',
}: {
  className?: Argument
  isLeftAligned?: boolean
  variant?: 'title' | 'subheading' | 'heading' | null
  as?: React.ElementType
} & (
  | { text?: never; children: ReactNode }
  | { children?: never; text: string }
)) => {
  return (
    <As
      className={classNames(
        'font-primary leading-[1.25] font-semibold whitespace-pre-line text-heading',
        {
          hyphenate: isHyphenatedLocale(),
          'mb-2 text-base': variant === 'subheading',
          'mb-2 text-lg': variant === 'heading',
          'mb-8 text-[22px] sm:mb-13 md:text-[32px]': variant === 'title',
          'text-center': !isLeftAligned,
        },
        className,
      )}
    >
      {text ?? children}
    </As>
  )
}

export default Heading
